import { useLayoutEffect, useRef, useState } from "react";
import ResizeObserverPolyfill from "resize-observer-polyfill";

const ResizeObserverClass =
  typeof window !== "undefined" && window.ResizeObserver
    ? window.ResizeObserver
    : ResizeObserverPolyfill;

export default function useResizeObserver(ref) {
  const [containerSize, setContainerSize] = useState({ width: 0, height: 0 });
  const observerRef = useRef(null);

  useLayoutEffect(() => {
    const node = ref?.current;
    if (!node) {
      return;
    }

    observerRef.current = new ResizeObserverClass((entries) => {
      const entry = entries[0];
      if (entry) {
        const { width, height } = entry.contentRect;

        // to prevent ResizeObserver loop limit exceeded in some ui tests
        window.requestAnimationFrame(() => setContainerSize({ width, height }));
      }
    });

    observerRef.current.observe(node);

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
    };
  }, [ref]);

  return containerSize;
}
